<template>
  <div class="main">
    <HeaderVue class="head" />
    <Sidebar class="sidebar" />
    <Dashboard title="Colheita">
      <b-row class="harvest">
        <b-col cols="6">
          <b-row>
            <Filters
              :description="true"
              :showDay="true"
              :showMonth="true"
              @changeDate="handleDateChange"
            />
          </b-row>
        </b-col>
        <b-col>
          <b-row class="justify-content-end mr-1">
            <b-button
              variant="outline-secondary"
              @click="openModalExportPdf()"
              class="mr-3"
            >
              <b-icon icon="download"></b-icon> Exportar
            </b-button>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="mt-4 mb-4">
        <b-col class="col-12" lg="10">
          <ListMonthlyHouses :date="dateFilter" :harvests="harvests" />
        </b-col>
      </b-row>
      <b-container fluid>
        <ListDailyHouses
          class="mt-4"
          @updateHarvests="handleUpdateHarvests"
          :data="dateFilter"
          :harvests="harvests"
        />
      </b-container>
    </Dashboard>
    <ModalEditPage />
    <ModalExportPdf @export-pdf="handleExportPdf" />
  </div>
</template>

<script>
/* eslint-disable global-require */
/* eslint-disable new-cap */
import JSPDF from 'jspdf';
import 'jspdf-autotable';

import Dashboard from '../components/Dashboard.vue';
import ListDailyHouses from '../components/harvest/ListDailyHouses.vue';
import ListMonthlyHouses from '../components/harvest/ListMonthlyHouses.vue';
import Filters from '../components/Filters.vue';
import HeaderVue from '../components/Header.vue';
import Sidebar from '../components/Sidebar.vue';
import ModalEditPage from '../components/harvest/ModalEditPage.vue';
import ModalExportPdf from '../components/harvest/ModalExportPdf.vue';
import MixinMontlyPDF from '../utils/MixinMontlyPDF';
import { Harvests } from '../services/Harvest';
import { Houses } from '../services/House';

export default {
  components: {
    HeaderVue,
    Sidebar,
    Dashboard,
    ListMonthlyHouses,
    ListDailyHouses,
    Filters,
    ModalEditPage,
    ModalExportPdf,
  },
  mixins: [MixinMontlyPDF],
  data() {
    return {
      harvests: [],
      houses: [],
      dateFilter: {
        day: '',
        month: '',
        year: null,
      },
      months: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ],
      currentMonth: null,
    };
  },
  methods: {
    async handleUpdateHarvests() {
      await Harvests().then((response) => {
        this.harvests = response.data;
      });
    },
    editPage() {
      this.$bvModal.show('modal-edit-page-harvest');
    },
    openModalExportPdf() {
      this.$bvModal.show('modal-export-pdf-harvest');
    },
    async printDayPDF(harvests, day, month, year) {
      const doc = new JSPDF();

      const x = 10; // Coordenada X da borda
      const y = 10; // Coordenada Y da borda

      const imageUrl = require('../assets/logo.jpg');
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);

      // Libera a URL do Blob
      URL.revokeObjectURL(blobUrl);

      this.addHeaderMontlyPDF(doc);
      this.addTitlePDF(doc, 'Colheita', `Dia ${day}/${month}`);
      this.addTableDayPDF(doc, harvests, this.houses, day, month, year);
      doc.save(`Colheita - ${day}-${this.months[month - 1]}-${year}.pdf`);
    },
    async printMonthPDF(harvests, month, year) {
      const doc = new JSPDF();

      const x = 10; // Coordenada X da borda
      const y = 10; // Coordenada Y da borda

      const imageUrl = require('../assets/logo.jpg');
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);

      // Libera a URL do Blob
      URL.revokeObjectURL(blobUrl);

      this.addHeaderMontlyPDF(doc);
      this.addTitlePDF(
        doc,
        'Colheita',
        `Dados gerais - ${this.months[month - 1]}`
      );
      this.addTableMontlyPDF(doc, harvests, this.houses, month, year);
      doc.save(`Colheita - ${this.months[month - 1]}-${year}.pdf`);
    },
    async printYearPDF(harvests, year) {
      const doc = new JSPDF();

      const x = 10; // Coordenada X da borda
      const y = 10; // Coordenada Y da borda

      const imageUrl = require('../assets/logo.jpg');
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      doc.addImage(blobUrl, 'JPEG', x + 4, y + 2, 50, 25);

      // Libera a URL do Blob
      URL.revokeObjectURL(blobUrl);

      this.addHeaderMontlyPDF(doc);
      this.addTitlePDF(doc, 'Colheita', `Dados anuais ${year}`);
      this.addTableYearPDF(doc, harvests, this.houses, year);
      doc.save(`Colheita - ${year}.pdf`);
    },
    handleExportPdf({ selectedOption, selectedDate }) {
      const date = new Date(`${selectedDate}T00:00:00`);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      // Faça algo com os valores selecionados recebidos

      const harvests = this.harvests.filter((h) => {
        const harvestDate = new Date(`${h.harvest_date}T00:00:00`);
        const harvestDay = harvestDate.getDate();
        const harvestMonth = harvestDate.getMonth() + 1;
        const harvestYear = harvestDate.getFullYear();

        if (selectedOption === 'day') {
          return (
            harvestDay === day && harvestMonth === month && harvestYear === year
          );
        }
        if (selectedOption === 'month') {
          return harvestMonth === month && harvestYear === year;
        }
        if (selectedOption === 'year') {
          return harvestYear === year;
        }
        return false;
      });

      if (selectedOption === 'day') {
        this.printDayPDF(harvests, day, month, year);
      } else if (selectedOption === 'month') {
        this.printMonthPDF(harvests, month, year);
      } else if (selectedOption === 'year') {
        this.printYearPDF(harvests, year);
      }
    },

    handleDateChange(data) {
      this.dateFilter = data.date;
    },
  },
  created() {
    Harvests().then((response) => {
      this.harvests = response.data;
    });
    Houses().then((response) => {
      this.houses = response.data;
    });
  },
};
</script>

<style scoped>
.harvest {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.btn-filters {
  min-width: fit-content !important;
  border: none;
  background-color: transparent;
}

.btn-filters:focus {
  border: none;
  outline: none;
}

.date-filters {
  background: #d9d9d9;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.editPage {
  border: none;
  color: white;
  background: rgba(103, 101, 101, 0.78);
  border-radius: 15px;
}

.editPage:hover {
  background: rgba(63, 61, 61, 0.78);
}

.editPage span {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
</style>
